import { Component, inject } from "@angular/core";
import { InstructionTableComponent } from "../instruction-table/instruction-table.component";
import { ApiService } from "../../../../services/api.service";
import { AlertService } from "../../../../shared/alert/alert.service";
import { SpinnerService } from "../../../../shared/spinner/spinner.service";
import { IInstructions } from "../../interfaces/i-instructions";
import { AlertEnum } from "../../../../shared/alert/alert.enum";
import { InstructionsService } from "../services/instructions.service";
import { MatButtonModule } from "@angular/material/button";
import { AutomationUtilityService } from "../../services/automation-utility.service";
import { AutomationAction, AutomationType } from "../../enums/automation.enum";

@Component({
  selector: "app-my-instructions",
  imports: [ InstructionTableComponent, MatButtonModule ],
  providers: [
    AutomationUtilityService
  ],
  templateUrl: "./my-instructions.component.html",
  styleUrl: "./my-instructions.component.scss",
})
export class MyInstructionsComponent {
  gridData: IInstructions[] = [];
  isLoading = true;

  #apiService = inject(ApiService);
  #alertService = inject(AlertService);
  #spinnerService = inject(SpinnerService);
  #instructionsService = inject(InstructionsService);
  #automationUtilityService = inject(AutomationUtilityService);

  constructor() {
    this.#spinnerService.show();
    this.#apiService.getMyInstructions().subscribe({
      next: (response) => {
        this.gridData = response;
        // Update the instructions service with the fetched instructions
        this.#instructionsService.instructions.set(this.gridData);
        this.isLoading = false;
        this.#spinnerService.hide();
      },
      error: (error: any) => {
        this.#spinnerService.hide();
        this.#alertService.showAlert({
          message: `Failed to get your Instructions.`,
          type: AlertEnum.error,
        });
        this.isLoading = false;
      }
    });
  }

  /**
   * Creates a new instruction.
   */
  onCreate(): void {
    this.#automationUtilityService.createItem(AutomationType.INSTRUCTION, AutomationAction.CREATE);
  }

}
